/* ---------- CP-001's earth studs -U1/-U2 to -XE1/-XE2 (#2169 item 10; engineer 3, 6231436011) ----------
 * The plate's and the door's earth studs connect the protective conductor to the part: IEC 81346-2's class X, an interfacing object, not
 * U, a holding object. A save made with the old tags names them as devices ({ tag: "U1" }), in every terminal reference on them ("U1:PE",
 * "WE1:3|U1:PE"), and in the panel as built when tested ("U1@{…}"). The motor's terminals ("MA1:U1", { terminalId: "U1" }) stay: they
 * are not the studs. The save migration in packages/progress uses this (format 20); nothing else does. Self-contained on purpose: the
 * migration imports this file alone, not CP-001's model. */

/** Each stud's old tag and its new one (without the leading dash). */
export const CP001_STUD_RENAME: Readonly<Record<string, string>> = { U1: "XE1", U2: "XE2" };

/** A stud where it stands as a whole tag in a reference: its terminal ("U1:PE") or its placement ("U1@{…}"); never "MA1:U1". */
const ON_STUD = /(?<![\w:/@-])U([12])(?=:PE\b|@)/g;
const renamed = (s: string) => s.replace(ON_STUD, (t: string) => CP001_STUD_RENAME[t]);

function walk(v: any, key?: string): any {
  if (typeof v === "string") return key === "tag" && v in CP001_STUD_RENAME ? CP001_STUD_RENAME[v] : renamed(v);
  if (Array.isArray(v)) return v.map(x => walk(x));
  if (v && typeof v === "object") return Object.fromEntries(Object.entries(v).map(([k, x]) => [renamed(k), walk(x, k)]));
  return v;
}

const one = <A extends { model?: any; ui?: any }>(s: A): A => {
  const asText = typeof s.model === "string", model = walk(asText ? JSON.parse(s.model) : s.model ?? null);
  return { ...s, model: asText ? JSON.stringify(model, null, 2) : model, ui: walk(s.ui ?? {}) };
};
/** A saved CP-001 project ({ model, ui }, the model as a JSON string or an object, as saved) with the studs' new tags: its own work and
 *  each earlier attempt it keeps ("Start again", #1220). */
export function renameCp001Studs<T extends { model?: any; ui?: any; attempts?: any[] }>(s: T): T {
  const out = one(s);
  return Array.isArray(s.attempts) ? { ...out, attempts: s.attempts.map(a => one(a)) } : out;
}
